import { render, staticRenderFns } from "./Intervention.vue?vue&type=template&id=b54167ac&"
import script from "./Intervention.vue?vue&type=script&lang=js&"
export * from "./Intervention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports